import PropTypes from "prop-types";
import React, { Component, createRef } from "react";
import {
  Box,
  Checkbox,
  Chip,
  CircularProgress,
  FormControl,
  FormControlLabel,
  Grid,
  Icon as MuiIcon,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Tooltip,
  Typography
} from "@material-ui/core";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import styled from "styled-components";
import _ from "lodash";
import { Formik } from "formik";
import { withRouter } from "react-router-dom";
import moment from "moment";
import { withAlert } from "react-alert";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import Group from "../../waybee-ui/Group";
import BlockButton from "../../waybee-ui/BlockButton";
import BackButton from "../../components/BackButton";
import TableGrid from "../../waybee-ui/TableGrid";
import TeacherService from "../../services/TeacherService";
import GridFrequencyService from "../../services/GridFrequencyService";
import fetchGradeJobQueue from "../../utils/fetchGradeJobQueue";
import { isJobInProgress } from "../../utils/jobHelpers";
import JobInProgressLoading from "../../components/JobInProgressLoading";
import { enrichOccurrenceStudentsWithDayAbsence } from "../../utils/frequencySessionHelpers";
import Button from "../../waybee-ui/Button";
import Heading from "../../waybee-ui/Heading";
import MultiAvatar from "../../waybee-ui/MultiAvatar";
import Dialog from "../../waybee-ui/Dialog";
import DialogTitle from "../../waybee-ui/Dialog/DialogTitle";
import DialogContent from "../../waybee-ui/Dialog/DialogContent";
import DialogActions from "../../waybee-ui/Dialog/DialogActions";
import MultiOccurrencesForm from "./components/MultiOccurrencesForm";
import decodeBase64 from "../../utils/decodeBase64";
import {
  OCCURRENCE_ATTACHMENT_ACCEPT,
  filterAllowedAttachments,
  notifyRejectedAttachment
} from "../../utils/occurrenceAttachmentRules";
import { Can } from "../../acl/can";
import UserStore from "../../utils/UserStore";
import { clearLeaveGuard, setLeaveGuard } from "../../utils/leaveGuard";

function toLessonQueryDate(value) {
  if (!value) return null;
  const day = moment.utc(value);
  if (!day.isValid()) return null;
  return `${day.format("YYYY-MM-DD")}T12:00:00`;
}

function defaultOccurrenceLessonDate() {
  const ano = Number(UserStore.getAnoLetivo());
  const today = moment();
  if (!ano || today.year() === ano) {
    return today.format("YYYY-MM-DDTHH:mm:ss");
  }
  return toLessonQueryDate(`${ano}-12-19`);
}

const LoadContainer = styled.div`
  width: 100%;
  text-align: center;
  padding: 32px 8px;
`;

const Icon = styled(MuiIcon)`
  margin-right: 8px;
`;

const LessonFilterRow = styled(Grid)`
  align-items: flex-end;
`;

const LessonInfoWrap = styled(Grid)`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-bottom: 4px;
`;

const SelectedInfo = styled.div`
  display: flex;
  margin: 0 -20px;
  padding: 20px 20px;
  justify-content: space-between;
  align-items: center;
  &:hover {
    background-color: #c8c8c8;
    cursor: pointer;
  }
`;
const SelectedAmount = styled.p`
  margin-right: auto;
  color: black;
  font-size: 22px;
  margin-left: 20px;
`;
const ChangeSelect = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.color.secondary.main};
  font-size: 16px;
  text-decoration: underline;
`;
const AttachmentButton = styled(Grid)`
  display: flex;
  align-items: center;
`;

const AbsentEarlierHint = styled(Typography)`
  color: #e65100;
  font-size: 12px;
  margin-top: 4px;
`;

/** Normaliza Motivo many2many: array, valor único ou vazio → array de ids. */
function toReasonIds(selected) {
  if (Array.isArray(selected)) return selected;
  if (selected) return [selected];
  return [];
}

class Occurrences extends Component {
  constructor(props) {
    super(props);
    this.state = {
      classId:
        (props.match && props.match.params && props.match.params.id) || null,
      filter: {
        lesson: ""
      },
      selectedLessonDate: defaultOccurrenceLessonDate(),
      selectedTurmaDisc: "",
      loadingSave: false,
      loadingSchedules: true,
      schedulesError: false,
      loadingOccurrences: false,
      loadingAttachments: "",
      schedules: [],
      types: [],
      students: [],
      selectedStudents: [],
      selectAll: false,
      selectAbsentToday: false,
      multipleLaunch: false,
      openChangeSelectDialog: false,
      multiOccurrence: {},
      formDirty: false,
      loadingJobs: [],
      processedJobs: [],
      loadingMessage: ""
    };
  }

  componentDidMount() {
    this.getSchedules();
  }

  componentDidUpdate(prevProps, prevState) {
    setLeaveGuard(
      () => this.hasPendingListChanges() || this.hasPendingMultiChanges()
    );
    const { selectedTurmaDisc } = this.state;
    if (selectedTurmaDisc !== prevState.selectedTurmaDisc) {
      this.getOccurrenceTypes(selectedTurmaDisc);
    }
    this.checkOccurrenceJobCompletion(prevProps);
  }

  componentWillUnmount() {
    clearLeaveGuard();
  }

  handleOccurrenceJobCompleted = (jobId, pendingJobKey, schedule) => {
    const { jobsState } = this.props;
    const { classId } = this.state;

    const stillPending = jobsState.jobs.some(
      job =>
        job.id !== jobId &&
        isJobInProgress(job) &&
        this.matchesPendingOccurrenceJob(job, classId, schedule)
    );

    if (stillPending) {
      this.setState(prev => ({
        processedJobs: [...prev.processedJobs, jobId]
      }));
      return;
    }

    this.setState(
      prev => ({
        loadingJobs: prev.loadingJobs.filter(
          jobKey => jobKey !== pendingJobKey
        ),
        processedJobs: [...prev.processedJobs, jobId]
      }),
      () => {
        if (!schedule) {
          return;
        }
        this.getOccurrences(
          schedule.idTurmaDisc,
          this.formatSelectedDate(schedule),
          schedule.scheduleId,
          schedule.weekDay,
          schedule
        );
      }
    );
  };

  getSelectedSchedule = () => {
    const { filter, schedules } = this.state;
    return schedules.find(schedule => schedule.id === filter.lesson);
  };

  getPendingOccurrenceJobKey = (classId, schedule) => {
    if (!classId || !schedule || !schedule.idTurmaDisc) {
      return null;
    }
    const date = this.formatSelectedDate(schedule);
    if (!date) {
      return null;
    }
    return `${classId}${schedule.idTurmaDisc}${date}`;
  };

  getStudentAttachment = async (occurrenceId, studentId, setFieldValue) => {
    this.setState({ loadingAttachments: studentId });
    const occurrenceAttachment = await TeacherService.occurrenceAttachments(
      occurrenceId
    );
    if (setFieldValue) {
      const { occurrenceGroupId } = occurrenceAttachment;
      setFieldValue(`filesAttached-${studentId}-${occurrenceGroupId}`, [
        occurrenceAttachment
      ]);
    }
    this.setState({ loadingAttachments: "" });
    return occurrenceAttachment;
  };

  getOccurrenceTypes = async idTurmaDisc => {
    const classId = localStorage.getItem("class");
    const occurrenceTypes = await TeacherService.getOccurrenceTypes(
      classId,
      idTurmaDisc
    );
    this.setState({ types: occurrenceTypes });
  };

  getOccurrences = async (idTurmaDisc, date, scheduleId, weekDay, schedule) => {
    const { alert, t } = this.props;
    this.setState({ loadingOccurrences: true, selectedTurmaDisc: idTurmaDisc });

    try {
      const studentsOccurrences = await TeacherService.getOccurrence(
        idTurmaDisc,
        date,
        scheduleId,
        weekDay
      );
      const studentsForms = studentsOccurrences.map(occur => {
        const newOccur = occur;
        newOccur.formRef = createRef();
        occur.occurrences.map(async occurrence => {
          if (occurrence.attachmentsCount > 0) {
            this.setState({ loadingAttachments: occur.ra });
            await this.getStudentAttachment(occurrence.idOccur, occur.ra).then(
              res => {
                newOccur.formRef.current.values[
                  `filesAttached-${occur.ra}-${res.occurrenceGroupId}`
                ] = res.occurAttachment.map(attachment => {
                  return {
                    occurrenceId: occurrence.idOccur,
                    attachmentId: attachment.attachmentId,
                    name: attachment.attachmentName,
                    content: attachment.attachmentData
                  };
                });
                this.setState({ loadingAttachments: "" });
              }
            );
          }

          return false;
        });
        return newOccur;
      });

      const { schedules, filter } = this.state;
      const resolvedSchedule =
        schedule ||
        schedules.find(
          item =>
            String(item.scheduleId) === String(scheduleId) &&
            String(item.idTurmaDisc) === String(idTurmaDisc)
        ) ||
        schedules.find(item => item.id === filter.lesson);

      let enrichedStudents = studentsForms.map(student => ({
        ...student,
        absentEarlierSameDay: false,
        absentToday: !!student.absence
      }));

      if (resolvedSchedule) {
        try {
          const dayStr = moment(resolvedSchedule.date).format("YYYY-MM-DD");
          const grid = await GridFrequencyService.getFrequency(
            idTurmaDisc,
            `${dayStr}T00:00:00`,
            `${dayStr}T23:59:59`
          );
          enrichedStudents = enrichOccurrenceStudentsWithDayAbsence(
            studentsForms,
            resolvedSchedule,
            grid
          );
        } catch (e) {
          console.error(e);
        }
      }

      this.setState(
        {
          students: enrichedStudents,
          selectedStudents: [],
          selectAll: false,
          selectAbsentToday: false,
          loadingOccurrences: false
        },
        () => {
          this.syncOccurrenceJobQueue();
        }
      );
    } catch (e) {
      console.error(e);
      this.setState({
        loadingOccurrences: false,
        students: [],
        selectedStudents: [],
        selectAll: false,
        selectAbsentToday: false
      });
      alert.show(t("occurrences.error.schedules"), {
        title: t("common.actions.error")
      });
    }
  };

  setFilter(field, value) {
    const { filter } = this.state;
    this.setState({
      filter: {
        ...filter,
        [field]: value
      }
    });
  }

  matchesPendingOccurrenceJob = (job, classId, schedule) => {
    if (!job || !classId || !schedule) {
      return false;
    }
    const date = this.formatSelectedDate(schedule);
    return (
      job.name === "save_occurrences" &&
      job.classId === classId &&
      String(job.course) === String(schedule.idTurmaDisc) &&
      job.period === date
    );
  };

  checkOccurrenceJobCompletion = prevProps => {
    const {
      jobsState: { jobs }
    } = this.props;
    const { classId, loadingJobs, processedJobs } = this.state;
    const schedule = this.getSelectedSchedule();
    const pendingJobKey = this.getPendingOccurrenceJobKey(classId, schedule);

    if (!pendingJobKey || loadingJobs.length === 0 || jobs.length < 1) {
      return;
    }

    jobs.forEach(job => {
      const previousJob = prevProps.jobsState.jobs.find(
        prevJob => prevJob.id === job.id
      );
      const hasProcessed = processedJobs.includes(job.id);

      if (
        !hasProcessed &&
        (job.status === "success" || job.status === "error") &&
        previousJob &&
        job.status !== previousJob.status &&
        this.matchesPendingOccurrenceJob(job, classId, schedule)
      ) {
        this.handleOccurrenceJobCompleted(job.id, pendingJobKey, schedule);
      }
    });
  };

  syncOccurrenceJobQueue = () => {
    const { jobsState, t } = this.props;
    const { classId, loadingJobs } = this.state;
    const schedule = this.getSelectedSchedule();
    const pendingJobKey = this.getPendingOccurrenceJobKey(classId, schedule);

    if (!pendingJobKey || !jobsState || !jobsState.jobs) {
      return;
    }

    jobsState.jobs.forEach(job => {
      if (
        isJobInProgress(job) &&
        this.matchesPendingOccurrenceJob(job, classId, schedule) &&
        !loadingJobs.includes(pendingJobKey)
      ) {
        this.setState(prevState => ({
          loadingJobs: [...prevState.loadingJobs, pendingJobKey],
          loadingMessage: t("occurrences.jobInProgressLesson")
        }));
      }
    });
  };

  downloadFile = (attachmentData, attachmentName) => {
    const decodedUrl = decodeBase64(attachmentData);

    const downloadLink = document.createElement("a");
    downloadLink.href = decodedUrl;
    downloadLink.download = attachmentName;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  pickDefaultSchedule = schedules => {
    if (!schedules.length) return null;
    return schedules[0];
  };

  handleScheduleDateChange = async date => {
    if (!date || !moment(date).isValid()) return;
    const nextDate = toLessonQueryDate(date);
    if (!nextDate) return;
    await this.setState({
      selectedLessonDate: nextDate
    });
    this.getSchedules();
  };

  getSchedules = async () => {
    this.setState({ loadingSchedules: true, schedulesError: false });
    const { selectedLessonDate } = this.state;
    const { match, alert, t } = this.props;
    const classId = match.params.id;

    try {
      const schedules = await TeacherService.getScheduleForOccurrence(classId, {
        date: selectedLessonDate
      });
      const defaultSchedule = this.pickDefaultSchedule(schedules);
      this.setState(
        {
          schedules,
          classId,
          loadingSchedules: false,
          filter: { lesson: defaultSchedule ? defaultSchedule.id : "" },
          selectedTurmaDisc: defaultSchedule ? defaultSchedule.idTurmaDisc : "",
          ...(defaultSchedule ? {} : { students: [] })
        },
        () => {
          if (defaultSchedule) {
            this.getOccurrences(
              defaultSchedule.idTurmaDisc,
              this.formatSelectedDate(defaultSchedule),
              defaultSchedule.scheduleId,
              defaultSchedule.weekDay,
              defaultSchedule
            );
          }
        }
      );
    } catch (e) {
      console.error(e);
      this.setState({ classId, loadingSchedules: false, schedulesError: true });
      alert.show(t("occurrences.error.schedules"), {
        title: t("common.actions.error")
      });
    }
  };

  updateStudent = (studentId, prop, value) => {
    this.setState(prevState => {
      const student = prevState.students.find(e => {
        return e.id === studentId;
      });
      student[prop] = value;
      return student;
    });
  };

  getReasons = () => {
    const { types } = this.state;
    const reasons = types.map(type => type.reasons);
    return _.flatten(reasons);
  };

  getInsertData = (occurrences, absences, schedule) => {
    const { students } = this.state;

    let oldOccurrences = students.map(std =>
      std.occurrences.map(occur => ({
        studentId: std.id,
        ...occur
      }))
    );
    oldOccurrences = _.flatten(oldOccurrences);

    const oldAbsences = students.map(std => ({
      studentId: std.id,
      value: std.absence ? "A" : "P"
    }));

    const removedOccurrences = _.differenceWith(
      oldOccurrences,
      occurrences,
      (a, b) =>
        a.studentId === b.studentId &&
        a.idGroup === b.idGroup &&
        a.idType === b.idType &&
        a.description === b.description &&
        a.files === b.files
    );
    const newOccurrences = _.differenceWith(
      occurrences,
      oldOccurrences,
      (a, b) =>
        a.studentId === b.studentId &&
        a.idGroup === b.idGroup &&
        a.idType === b.idType &&
        a.description === b.description &&
        a.files === b.files
    );

    const newAbsences = _.differenceWith(
      absences,
      oldAbsences,
      (a, b) => a.value === b.value && a.studentId === b.studentId
    );

    const date = this.formatSelectedDate(schedule);

    return {
      idTurmaDisc: schedule.idTurmaDisc,
      idPerlet: schedule.idPerLet,
      date,
      scheduleId: schedule.scheduleId,
      occurrences: newOccurrences,
      removed: removedOccurrences,
      absences: newAbsences
    };
  };

  markFormDirty = () => {
    const { formDirty } = this.state;
    if (!formDirty) {
      this.setState({ formDirty: true });
    }
  };

  /** Monta o payload atual a partir dos forms (mesma lógica do save). */
  buildCurrentSavePayload = () => {
    const { students, filter, schedules } = this.state;
    if (!students.length || !filter.lesson) return null;

    const reasons = this.getReasons();
    const formsValues = students
      .map(
        std => std.formRef && std.formRef.current && std.formRef.current.values
      )
      .filter(Boolean);

    if (formsValues.length !== students.length) return null;

    const occurrences = [];
    const absences = [];

    formsValues.forEach(val => {
      (val.occurrences || []).forEach(occur => {
        if (occur.reasons && occur.reasons.length) return;
        occurrences.push({
          studentId: val.student,
          idGroup: occur.idGroup,
          idType: occur.idType
        });
      });

      Object.keys(val).forEach(key => {
        if (!key.includes("reason-")) return;
        const reasonIds = toReasonIds(val[key]);
        if (!reasonIds.length) return;
        const typeId = key.split("reason-")[1];
        const description = val[`description-${typeId}`];

        reasonIds.forEach(reasonId => {
          const foundReason = reasons.find(reason => reason.id === reasonId);
          if (!foundReason) return;

          const occurrence = {
            studentId: val.student,
            idGroup: foundReason.idGroup,
            idType: foundReason.idType,
            description
          };

          const filesAttached = [];
          if (val[`filesPending-${val.student}-${foundReason.idGroup}`]) {
            val[
              `filesPending-${val.student}-${foundReason.idGroup}`
            ].forEach(filePending => filesAttached.push(filePending));
          }
          if (val[`filesAttached-${val.student}-${foundReason.idGroup}`]) {
            val[
              `filesAttached-${val.student}-${foundReason.idGroup}`
            ].forEach(file => filesAttached.push(file));
          }
          if (filesAttached.length) {
            occurrence.files = filesAttached.map(file => ({
              attachmentId: file.attachmentId,
              name: file.name,
              content: file.content
            }));
          }
          occurrences.push(occurrence);
        });
      });

      absences.push({
        studentId: val.student,
        idTurmaDisc: val.idTurmaDisc,
        idSchedule: val.idSchedule,
        value: val.absence ? "A" : "P"
      });
    });

    const foundSchedule = schedules.find(
      schedule => schedule.id === filter.lesson
    );
    if (!foundSchedule) return null;

    return this.getInsertData(occurrences, absences, foundSchedule);
  };

  hasPendingListChanges = () => {
    const { formDirty } = this.state;
    return !!formDirty;
  };

  hasPendingMultiChanges = () => {
    const { multiOccurrence } = this.state;
    if (!multiOccurrence) return false;
    if (multiOccurrence.absence) return true;
    if (multiOccurrence.occurrences && multiOccurrence.occurrences.length) {
      return true;
    }
    return Object.keys(multiOccurrence).some(key => {
      if (!key.includes("reason-")) return false;
      return toReasonIds(multiOccurrence[key]).length > 0;
    });
  };

  insertOccurrence = async (data, foundSchedule) => {
    const { alert, t } = this.props;
    const { classId } = this.state;

    try {
      const date = this.formatSelectedDate(foundSchedule);
      const courseId = foundSchedule.idTurmaDisc;
      await TeacherService.saveOccurrence(data, {
        classId,
        filter: {
          course: { id: courseId },
          period: date
        }
      });

      alert.show(t("common.messages.processingRequest"), {
        title: t("occurrences.sent")
      });

      const pendingJobKey = this.getPendingOccurrenceJobKey(
        classId,
        foundSchedule
      );
      this.setState(
        prevState => ({
          loadingJobs:
            pendingJobKey && !prevState.loadingJobs.includes(pendingJobKey)
              ? [...prevState.loadingJobs, pendingJobKey]
              : prevState.loadingJobs,
          loadingMessage: t("occurrences.jobInProgressLesson")
        }),
        () => {
          fetchGradeJobQueue();
        }
      );
    } catch (e) {
      const message = _.get(
        e,
        "response.data.error.message",
        t("occurrences.saveError")
      );
      alert.show(message, { title: t("common.actions.error") });
    } finally {
      this.setState({ loadingSave: false });
    }
  };

  /** Tipos selecionados que exigem Motivo, mas ainda sem motivo escolhido. */
  hasIncompleteOccurrenceReasons = () => {
    const { students } = this.state;
    return students.some(std => {
      const values =
        std.formRef && std.formRef.current && std.formRef.current.values;
      if (!values) return false;
      return (values.occurrences || []).some(occur => {
        if (!occur.reasons || !occur.reasons.length) return false;
        return toReasonIds(values[`reason-${occur.id}`]).length === 0;
      });
    });
  };

  save = async () => {
    const { alert, t } = this.props;

    if (this.hasIncompleteOccurrenceReasons()) {
      alert.show(t("occurrences.selectReason"), {
        title: t("common.actions.attention")
      });
      return;
    }

    const data = this.buildCurrentSavePayload();
    if (
      !data ||
      !(
        (data.occurrences && data.occurrences.length) ||
        (data.removed && data.removed.length) ||
        (data.absences && data.absences.length)
      )
    ) {
      alert.show(t("occurrences.noChanges"), {
        title: t("common.actions.attention")
      });
      return;
    }

    const { filter, schedules } = this.state;
    const foundSchedule = schedules.find(
      schedule => schedule.id === filter.lesson
    );

    this.setState({ loadingSave: true });
    await this.insertOccurrence(data, foundSchedule);
    this.setState({ formDirty: false });
  };

  saveMultiOccurrence = async () => {
    const { multiOccurrence, selectedStudents, filter, schedules } = this.state;
    const { alert, t } = this.props;

    if (!this.hasPendingMultiChanges()) {
      alert.show(t("occurrences.noChanges"), {
        title: t("common.actions.attention")
      });
      return;
    }

    this.setState({ loadingSave: true });

    const reasons = this.getReasons();

    const occurrences = [];
    const absences = [];

    selectedStudents.forEach(student => {
      (multiOccurrence.occurrences || []).forEach(occur => {
        if (occur.reasons && occur.reasons.length) return;
        occurrences.push({
          studentId: student.id,
          idGroup: occur.idGroup,
          idType: occur.idType
        });
      });

      const valKeys = Object.keys(multiOccurrence);
      valKeys.forEach(key => {
        if (!key.includes("reason-")) return;

        const reasonIds = toReasonIds(multiOccurrence[key]);
        if (!reasonIds.length) return;

        const typeId = key.split("reason-")[1];
        const description = multiOccurrence[`description-${typeId}`];

        reasonIds.forEach(reasonId => {
          const foundReason = reasons.find(reason => reason.id === reasonId);
          if (!foundReason) return;
          occurrences.push({
            studentId: student.id,
            idGroup: foundReason.idGroup,
            idType: foundReason.idType,
            description
          });
        });
      });

      absences.push({
        studentId: student.id,
        idTurmaDisc: student.idTurmaDisc,
        idSchedule: student.idSchedule,
        value: multiOccurrence.absence ? "A" : "P"
      });
    });

    const foundSchedule = schedules.find(
      schedule => schedule.id === filter.lesson
    );

    const data = this.getInsertData(occurrences, absences, foundSchedule);
    await this.insertOccurrence(data, foundSchedule);
    this.setState({
      multipleLaunch: false,
      selectAll: false,
      selectAbsentToday: false,
      multiOccurrence: {},
      formDirty: false
    });
  };

  changeSchedule = scheduleId => {
    const { schedules, classId, loadingJobs } = this.state;
    const { jobsState, t } = this.props;
    const selectedSchedule = schedules.find(
      schedule => schedule.id === scheduleId
    );
    if (!selectedSchedule) {
      return;
    }

    const date = this.formatSelectedDate(selectedSchedule);
    const pendingJobKey = this.getPendingOccurrenceJobKey(
      classId,
      selectedSchedule
    );
    const hasPendingInQueue = (jobsState.jobs || []).some(
      job =>
        isJobInProgress(job) &&
        this.matchesPendingOccurrenceJob(job, classId, selectedSchedule)
    );

    this.setState({ formDirty: false });

    if (
      pendingJobKey &&
      (loadingJobs.includes(pendingJobKey) || hasPendingInQueue)
    ) {
      if (hasPendingInQueue && !loadingJobs.includes(pendingJobKey)) {
        this.setState(prevState => ({
          loadingJobs: [...prevState.loadingJobs, pendingJobKey],
          loadingMessage: t("occurrences.jobInProgressLesson")
        }));
      }
      return;
    }

    this.getOccurrences(
      selectedSchedule.idTurmaDisc,
      date,
      selectedSchedule.scheduleId,
      selectedSchedule.weekDay,
      selectedSchedule
    );
  };

  formatSelectedDate = schedule => {
    const [hour, minute] = schedule.startTime.split(":");
    return moment(schedule.date)
      .set({ hour, minute })
      .format("YYYY-MM-DD HH:mm:SS");
  };

  getInitialState = student => {
    const { types } = this.state;

    const reasons = {};
    const typeIdsAdded = new Set();
    const formattedOccurrences = [];

    (student.occurrences || []).forEach(occur => {
      const type = types.find(candidate => {
        if (occur.id === candidate.id) return true;
        return candidate.reasons.some(reason => reason.id === occur.id);
      });
      if (!type) return;

      if (!typeIdsAdded.has(type.id)) {
        formattedOccurrences.push(type);
        typeIdsAdded.add(type.id);
      }

      const foundReason = type.reasons.find(reason => reason.id === occur.id);
      if (foundReason) {
        const key = `reason-${type.id}`;
        if (!Array.isArray(reasons[key])) reasons[key] = [];
        if (!reasons[key].includes(foundReason.id)) {
          reasons[key].push(foundReason.id);
        }
        if (occur.description) {
          reasons[`description-${type.id}`] = occur.description;
        }
      }
    });

    return {
      student: student.id,
      idTurmaDisc: student.idTurmaDisc,
      idSchedule: student.idSchedule,
      absence: student.absence,
      occurrences: formattedOccurrences,
      ...reasons
    };
  };

  onChangeOccurrences = (oldVal, newVal, setFieldValue) => {
    const removed = _.difference(oldVal, newVal);
    if (removed.length && removed[0].reasons.length) {
      setFieldValue(`reason-${removed[0].id}`, []);
      setFieldValue(`description-${removed[0].id}`, null);
    }
    this.markFormDirty();
  };

  onSelectStudent = student => {
    const { selectedStudents, students } = this.state;

    const foundStudents = selectedStudents.find(
      selected => selected.id === student.id
    );

    const newSelectedStudents = foundStudents
      ? selectedStudents.filter(select => select.id !== foundStudents.id)
      : [...selectedStudents, student];

    this.setState({
      selectedStudents: newSelectedStudents,
      selectAbsentToday: false,
      selectAll: newSelectedStudents.length === students.length
    });
  };

  onSelectAll = value => {
    const { selectedStudents, students } = this.state;
    if (selectedStudents.length !== students.length) {
      this.setState({
        selectedStudents: students,
        selectAll: value,
        selectAbsentToday: false
      });
    } else {
      this.setState({
        selectedStudents: [],
        selectAll: value,
        selectAbsentToday: false
      });
    }
  };

  onSelectAbsentToday = () => {
    const { students, selectedStudents } = this.state;
    const absentStudents = students.filter(student => student.absentToday);
    const allAbsentSelected =
      absentStudents.length > 0 &&
      absentStudents.every(absent =>
        selectedStudents.find(selected => selected.id === absent.id)
      );

    if (allAbsentSelected) {
      const nextSelected = selectedStudents.filter(
        selected => !selected.absentToday
      );
      this.setState({
        selectedStudents: nextSelected,
        selectAll: nextSelected.length === students.length,
        selectAbsentToday: false
      });
      return;
    }

    const merged = [...selectedStudents];
    absentStudents.forEach(student => {
      if (!merged.find(selected => selected.id === student.id)) {
        merged.push(student);
      }
    });

    this.setState({
      selectedStudents: merged,
      selectAll: merged.length === students.length,
      selectAbsentToday: true
    });
  };

  openMultipleLaunch = () => {
    const { students, selectedStudents } = this.state;
    const merged = [...selectedStudents];

    students
      .filter(student => student.absentToday)
      .forEach(student => {
        if (!merged.find(selected => selected.id === student.id)) {
          merged.push(student);
        }
      });

    const hasAbsentStudents = merged.some(student => student.absentToday);

    this.setState({
      multipleLaunch: true,
      selectedStudents: merged,
      selectAll: merged.length === students.length,
      selectAbsentToday: hasAbsentStudents,
      multiOccurrence: hasAbsentStudents
        ? { absence: true, occurrences: [] }
        : {}
    });
  };

  handleFileSelect = (
    e,
    prevFiles,
    setFieldValue,
    studentId,
    occurrenceGroupId
  ) => {
    const { alert, t } = this.props;
    const files = filterAllowedAttachments(
      e.target.files,
      notifyRejectedAttachment(alert, t)
    );
    if (files.length > 0) {
      this.markFormDirty();
      for (let i = 0; i < files.length; i += 1) {
        const file = files[i];
        const reader = new FileReader();

        reader.onload = event => {
          const fileData = {
            id: file.lastModified + file.size,
            name: file.name,
            content: event.target.result.split(",")[1]
          };

          if (prevFiles) {
            setFieldValue(`filesPending-${studentId}-${occurrenceGroupId}`, [
              ...prevFiles,
              fileData
            ]);
          } else {
            setFieldValue(`filesPending-${studentId}-${occurrenceGroupId}`, [
              fileData
            ]);
          }
        };
        reader.readAsDataURL(file);
      }
    }
  };

  render() {
    const { t } = this.props;
    const {
      filter,
      loadingSave,
      loadingSchedules,
      schedulesError,
      loadingOccurrences,
      loadingAttachments,
      students,
      schedules,
      types,
      classId,
      selectedStudents,
      selectAll,
      selectAbsentToday,
      multipleLaunch,
      openChangeSelectDialog,
      multiOccurrence,
      loadingJobs,
      loadingMessage,
      selectedLessonDate
    } = this.state;

    const selectedSchedule = this.getSelectedSchedule();
    const pendingJobKey = this.getPendingOccurrenceJobKey(
      classId,
      selectedSchedule
    );
    const isOccurrenceJobPending =
      !!pendingJobKey && loadingJobs.includes(pendingJobKey);

    const absentTodayCount = students.filter(student => student.absentToday)
      .length;
    const canLaunchMultiple =
      !isOccurrenceJobPending &&
      (selectedStudents.length >= 1 || absentTodayCount >= 1);
    const canSaveList = !isOccurrenceJobPending && this.hasPendingListChanges();
    const canSaveMulti = this.hasPendingMultiChanges();
    const hasNoLessonsOccurrence =
      !loadingSchedules && !schedulesError && schedules.length === 0;

    return (
      <div>
        <Grid container spacing={2}>
          {multipleLaunch ? (
            <BackButton
              to={`/classes/${classId}/occurrences`}
              onClick={() => this.setState({ multipleLaunch: false })}
            />
          ) : (
            <BackButton to={`/classes/${classId}`} />
          )}
          {!multipleLaunch && !hasNoLessonsOccurrence && (
            <Grid item xs={12}>
              <Group p={0}>
                <Can I="save" a="diaryOccurrences">
                  <BlockButton
                    disabled={!canSaveList}
                    onClick={() => this.save()}
                  >
                    {t("common.actions.save")}
                  </BlockButton>
                </Can>
              </Group>
            </Grid>
          )}
          {!multipleLaunch && (
            <Grid item xs={12}>
              <Group>
                <Box>
                  <Box pb={5} pt={1}>
                    <form noValidate autoComplete="off">
                      {loadingSchedules ? (
                        <LoadContainer>
                          <CircularProgress />
                        </LoadContainer>
                      ) : (
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <LessonFilterRow container spacing={4}>
                            <Grid item xs={12} sm={3}>
                              <KeyboardDatePicker
                                disableToolbar
                                variant="inline"
                                format="dd/MM/yyyy"
                                margin="normal"
                                label={t("common.labels.date")}
                                value={selectedLessonDate}
                                onChange={this.handleScheduleDateChange}
                                maxDate={new Date()}
                                disabled={
                                  loadingSchedules || isOccurrenceJobPending
                                }
                              />
                            </Grid>
                            <Grid item xs={12} sm={9}>
                              <FormControl fullWidth>
                                <InputLabel id="filter-classes-label">
                                  {t("common.labels.lessons")}
                                </InputLabel>
                                <Select
                                  fullWidth
                                  labelId="filter-classes-label"
                                  value={filter.lesson}
                                  onChange={e => {
                                    this.changeSchedule(e.target.value);
                                    this.setFilter("lesson", e.target.value);
                                  }}
                                  disabled={
                                    loadingSchedules || isOccurrenceJobPending
                                  }
                                >
                                  {schedules.map(lesson => (
                                    <MenuItem key={lesson.id} value={lesson.id}>
                                      {lesson.name}
                                      {' '}
                                      -
                                      {lesson.startTime}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </Grid>
                            <LessonInfoWrap item xs={12}>
                              <Tooltip
                                title={t("occurrences.mass.info")}
                                placement="left"
                              >
                                <IconButton
                                  aria-label={t("occurrences.mass.infoAria")}
                                  color="primary"
                                >
                                  <InfoOutlinedIcon />
                                </IconButton>
                              </Tooltip>
                            </LessonInfoWrap>
                            {!loadingOccurrences && !hasNoLessonsOccurrence && (
                              <Grid container item xs={12} spacing={4}>
                                <Grid item xs={4}>
                                  <FormControlLabel
                                    control={(
                                      <Checkbox
                                        checked={selectAll}
                                        onChange={e =>
                                          this.onSelectAll(e.target.checked)}
                                        color="primary"
                                      />
                                    )}
                                    label={t("occurrences.selectAll")}
                                  />
                                </Grid>
                                <Grid item xs={4}>
                                  <FormControlLabel
                                    control={(
                                      <Checkbox
                                        checked={selectAbsentToday}
                                        disabled={absentTodayCount === 0}
                                        onChange={this.onSelectAbsentToday}
                                        color="primary"
                                      />
                                    )}
                                    label={t("occurrences.selectAbsent", {
                                      count: absentTodayCount
                                    })}
                                  />
                                </Grid>
                                <Can I="save" a="diaryOccurrences">
                                  <Grid item xs={4}>
                                    <Button
                                      color="primary"
                                      variant="contained"
                                      disabled={!canLaunchMultiple}
                                      onClick={this.openMultipleLaunch}
                                    >
                                      {t("occurrences.launchMulti")}
                                    </Button>
                                  </Grid>
                                </Can>
                              </Grid>
                            )}
                          </LessonFilterRow>
                          {hasNoLessonsOccurrence && (
                            <Box pt={3}>
                              <Typography>
                                {t("occurrences.noLessonsOccurrence.body")}
                              </Typography>
                            </Box>
                          )}
                        </MuiPickersUtilsProvider>
                      )}
                    </form>
                  </Box>
                </Box>
                <Box>
                  {!hasNoLessonsOccurrence && (
                    <TableGrid>
                      {loadingOccurrences || isOccurrenceJobPending ? (
                        <JobInProgressLoading
                          inProgress={isOccurrenceJobPending}
                          message={
                            loadingMessage || t("occurrences.jobInProgress")
                          }
                        />
                      ) : (
                        students.map(student => {
                          const isStudentSelected = selectedStudents.some(
                            selected => selected.id === student.id
                          );
                          return (
                            <TableGrid.Row
                              key={student.id}
                              id={student.rollCallNum}
                              photo={student.photo}
                              photoName={student.name}
                              onSelect={() => this.onSelectStudent(student)}
                              checked={isStudentSelected}
                            >
                              <Formik
                                innerRef={student.formRef}
                                initialValues={this.getInitialState(student)}
                              >
                                {({ values, handleChange, setFieldValue }) => (
                                  <Grid container item xs={12}>
                                    <TableGrid.Group xs={6}>
                                      <TableGrid.Title xs={12}>
                                        {student.name}
                                      </TableGrid.Title>
                                      <TableGrid.Text xs={12}>
                                        {t("occurrences.ra", {
                                          ra: student.ra
                                        })}
                                      </TableGrid.Text>
                                      {student.absentEarlierSameDay && (
                                        <AbsentEarlierHint variant="caption">
                                          {t("occurrences.absentEarlier")}
                                        </AbsentEarlierHint>
                                      )}
                                    </TableGrid.Group>

                                    <TableGrid.MultiSelect
                                      name="occurrences"
                                      xs={4}
                                      label={t("occurrences.launch")}
                                      value={values.occurrences}
                                      disabled={values.absence}
                                      onChange={e => {
                                        this.onChangeOccurrences(
                                          values.occurrences,
                                          e.target.value,
                                          setFieldValue
                                        );
                                        handleChange(e);
                                        this.markFormDirty();
                                      }}
                                    >
                                      {types.map(occur => (
                                        <MenuItem key={occur.id} value={occur}>
                                          <Icon>{occur.icon}</Icon>
                                          {occur.name}
                                        </MenuItem>
                                      ))}
                                    </TableGrid.MultiSelect>

                                    <TableGrid.Checkbox
                                      xs={2}
                                      color="primary"
                                      label={t("occurrences.absent")}
                                      checked={values.absence}
                                      name="absence"
                                      onChange={e => {
                                        setFieldValue("occurrences", []);
                                        handleChange(e);
                                        this.markFormDirty();
                                      }}
                                    />
                                    {values.occurrences
                                      .filter(occur => occur.reasons.length)
                                      .map(occur => (
                                        <TableGrid.Cell
                                          key={occur.id}
                                          xs={12}
                                          style={{ marginBottom: "14px" }}
                                        >
                                          <Grid container spacing={4}>
                                            <Grid item xs={12}>
                                              <Box mt={3}>
                                                <Typography
                                                  variant="body1"
                                                  color="textSecondary"
                                                >
                                                  {t(
                                                    "occurrences.detailsAbout",
                                                    {
                                                      name: occur.name
                                                    }
                                                  )}
                                                </Typography>
                                              </Box>
                                            </Grid>
                                            <Grid item xs={6}>
                                              <FormControl fullWidth>
                                                <InputLabel
                                                  shrink={
                                                    !!(
                                                      values[
                                                        `reason-${occur.id}`
                                                      ] &&
                                                      values[
                                                        `reason-${occur.id}`
                                                      ].length
                                                    )
                                                  }
                                                  id={`motivo-label-${student.id}-${occur.id}`}
                                                >
                                                  {t("occurrences.reason")}
                                                </InputLabel>
                                                <Select
                                                  multiple
                                                  labelId={`motivo-label-${student.id}-${occur.id}`}
                                                  name={`reason-${occur.id}`}
                                                  value={
                                                    values[
                                                      `reason-${occur.id}`
                                                    ] || []
                                                  }
                                                  onChange={e => {
                                                    handleChange(e);
                                                    this.markFormDirty();
                                                  }}
                                                  renderValue={selected => (
                                                    <Box
                                                      display="flex"
                                                      flexWrap="wrap"
                                                      style={{ gap: 4 }}
                                                    >
                                                      {(selected || []).map(
                                                        id => {
                                                          const reason = occur.reasons.find(
                                                            item =>
                                                              item.id === id
                                                          );
                                                          return (
                                                            <Chip
                                                              key={id}
                                                              size="small"
                                                              label={
                                                                (reason &&
                                                                  reason.name) ||
                                                                id
                                                              }
                                                            />
                                                          );
                                                        }
                                                      )}
                                                    </Box>
                                                  )}
                                                >
                                                  {occur.reasons.map(reason => (
                                                    <MenuItem
                                                      key={reason.id}
                                                      value={reason.id}
                                                    >
                                                      <Checkbox
                                                        color="primary"
                                                        checked={(
                                                          values[
                                                            `reason-${occur.id}`
                                                          ] || []
                                                        ).includes(reason.id)}
                                                      />
                                                      {reason.name}
                                                    </MenuItem>
                                                  ))}
                                                </Select>
                                              </FormControl>
                                            </Grid>
                                            <Grid item xs={6}>
                                              {(
                                                values[`reason-${occur.id}`] ||
                                                []
                                              ).length > 0 && (
                                                <TextField
                                                  placeholder={t(
                                                    "common.labels.notesOptional"
                                                  )}
                                                  onChange={e => {
                                                    handleChange(e);
                                                    this.markFormDirty();
                                                  }}
                                                  fullWidth
                                                  multiline
                                                  rowsMax={5}
                                                  name={`description-${occur.id}`}
                                                  value={
                                                    values[
                                                      `description-${occur.id}`
                                                    ] || ""
                                                  }
                                                  margin="normal"
                                                />
                                              )}
                                            </Grid>
                                            {(
                                              values[`reason-${occur.id}`] || []
                                            ).length > 0 && (
                                              <AttachmentButton item xs={3}>
                                                <label
                                                  htmlFor={`files-container-${student.id}-${occur.id}`}
                                                >
                                                  <Button
                                                    variant="contained"
                                                    color="primary"
                                                    component="span"
                                                    startIcon={
                                                      <AttachFileIcon />
                                                    }
                                                    fullwidth
                                                  >
                                                    {t(
                                                      "occurrences.addAttachment"
                                                    )}
                                                  </Button>
                                                  <input
                                                    accept={
                                                      OCCURRENCE_ATTACHMENT_ACCEPT
                                                    }
                                                    id={`files-container-${student.id}-${occur.id}`}
                                                    name={`files-container-${student.id}-${occur.id}`}
                                                    multiple
                                                    type="file"
                                                    style={{ display: "none" }}
                                                    onChange={e => {
                                                      this.handleFileSelect(
                                                        e,
                                                        values[
                                                          `filesPending-${student.id}-${occur.idGroup}`
                                                        ],
                                                        setFieldValue,
                                                        student.id,
                                                        occur.idGroup
                                                      );
                                                      e.target.value = null;
                                                    }}
                                                  />
                                                </label>
                                              </AttachmentButton>
                                            )}
                                            {student.occurrences.length &&
                                            student.occurrences[0]
                                              .attachmentsCount > 0 &&
                                            !values[
                                              `filesAttached-${student.id}-${occur.idGroup}`
                                            ] ? (
                                              <Grid item xs={6}>
                                                {loadingAttachments !==
                                                student.id ? (
                                                  <Typography
                                                    variant="body1"
                                                    color="textSecondary"
                                                    onClick={() => {
                                                      if (
                                                        values[
                                                          `filesAttached-${student.id}-${occur.idGroup}`
                                                        ]
                                                      )
                                                        return setFieldValue(
                                                          `filesAttached-${student.id}-${occur.idGroup}`,
                                                          values[
                                                            `filesAttached-${student.id}-${occur.idGroup}`
                                                          ]
                                                        );
                                                      return this.getStudentAttachment(
                                                        student.occurrences[0]
                                                          .idOccur,
                                                        student.id,
                                                        setFieldValue
                                                      );
                                                    }}
                                                    style={{
                                                      cursor: "pointer",
                                                      textDecoration:
                                                        "underline"
                                                    }}
                                                  >
                                                    {t(
                                                      "occurrences.attachmentCount",
                                                      {
                                                        count:
                                                          student.occurrences[0]
                                                            .attachmentsCount
                                                      }
                                                    )}
                                                  </Typography>
                                                ) : (
                                                  <LoadContainer>
                                                    <CircularProgress />
                                                  </LoadContainer>
                                                )}
                                              </Grid>
                                            ) : (
                                              ""
                                            )}
                                            {values[
                                              `filesAttached-${student.id}-${occur.idGroup}`
                                            ] && (
                                              <Grid item xs={6}>
                                                <Typography
                                                  variant="body1"
                                                  color="textSecondary"
                                                >
                                                  {t("occurrences.attachments")}
                                                </Typography>
                                                {values[
                                                  `filesAttached-${student.id}-${occur.idGroup}`
                                                ].map(file => {
                                                  return (
                                                    <Chip
                                                      onClick={() =>
                                                        this.downloadFile(
                                                          file.attachmentData ||
                                                            file.content,
                                                          file.attachmentName ||
                                                            file.name
                                                        )}
                                                      key={
                                                        file.attachmentData ||
                                                        file.content
                                                      }
                                                      label={
                                                        file.attachmentName ||
                                                        file.name
                                                      }
                                                    />
                                                  );
                                                })}
                                              </Grid>
                                            )}
                                            {values[
                                              `filesPending-${student.id}-${occur.idGroup}`
                                            ] &&
                                            values[
                                              `filesPending-${student.id}-${occur.idGroup}`
                                            ].length ? (
                                              <Grid item xs={6}>
                                                <Typography
                                                  variant="body1"
                                                  color="textSecondary"
                                                >
                                                  {t("occurrences.attachments")}
                                                </Typography>
                                                {values[
                                                  `filesPending-${student.id}-${occur.idGroup}`
                                                ].map(file => {
                                                  return (
                                                    <Chip
                                                      onDelete={() => {
                                                        setFieldValue(
                                                          `filesPending-${student.id}-${occur.idGroup}`,
                                                          values[
                                                            `filesPending-${student.id}-${occur.idGroup}`
                                                          ].filter(
                                                            valFile =>
                                                              valFile.id !==
                                                              file.id
                                                          )
                                                        );
                                                      }}
                                                      key={file.name}
                                                      label={file.name}
                                                    />
                                                  );
                                                })}
                                              </Grid>
                                            ) : (
                                              ""
                                            )}
                                          </Grid>
                                        </TableGrid.Cell>
                                      ))}
                                  </Grid>
                                )}
                              </Formik>
                            </TableGrid.Row>
                          );
                        })
                      )}
                    </TableGrid>
                  )}
                </Box>
              </Group>
            </Grid>
          )}
          {multipleLaunch && (
            <Grid item xs={12}>
              <Group>
                <Box>
                  <Heading level={1} icon="change_history" gutterBottom>
                    {t("occurrences.multiDetails")}
                  </Heading>
                  <SelectedInfo
                    onClick={() =>
                      this.setState({ openChangeSelectDialog: true })}
                  >
                    <MultiAvatar
                      photos={selectedStudents.map(selected => ({
                        name: selected.name,
                        src: selected.photo
                      }))}
                      RoundedAvatarProps={{
                        size: 70
                      }}
                      maxItems={4}
                    />
                    <SelectedAmount>
                      {t("occurrences.studentsSelected", {
                        count: selectedStudents.length
                      })}
                    </SelectedAmount>

                    <ChangeSelect>
                      {t("occurrences.editSelection")}
                    </ChangeSelect>
                  </SelectedInfo>

                  <MultiOccurrencesForm
                    key={`multi-${selectedStudents.length}-${
                      multiOccurrence.absence ? "absence" : "occur"
                    }`}
                    types={types}
                    defaultAbsence={!!multiOccurrence.absence}
                    onChange={val =>
                      this.setState({ multiOccurrence: val, formDirty: true })}
                  />
                </Box>
              </Group>

              <Grid container item xs={12} justify="center">
                <Box mt={1.6}>
                  <Can I="save" a="diaryOccurrences">
                    <Button
                      color="primary"
                      variant="contained"
                      disabled={!canSaveMulti}
                      onClick={this.saveMultiOccurrence}
                    >
                      {t("common.actions.confirm")}
                    </Button>
                  </Can>
                </Box>
              </Grid>
            </Grid>
          )}
        </Grid>
        <Dialog
          onClose={() => this.setState({ loadingSave: false })}
          open={loadingSave}
        >
          <DialogTitle>{t("common.actions.saving")}</DialogTitle>
          <LoadContainer>
            <CircularProgress />
          </LoadContainer>
        </Dialog>

        <Dialog
          open={openChangeSelectDialog}
          onClose={() => this.setState({ openChangeSelectDialog: false })}
          maxWidth="md"
          fullWidth
          closeButton
        >
          <DialogTitle>{t("occurrences.manageSelected")}</DialogTitle>

          <DialogContent>
            <Box mb={4}>{t("occurrences.multiConfirmBody")}</Box>

            <TableGrid>
              {students.map(student => (
                <TableGrid.Row
                  key={student.ra}
                  id={student.rollCallNum}
                  photo={student.photo}
                  photoName={student.name}
                >
                  <TableGrid.Title xs={8}>{student.name}</TableGrid.Title>
                  <TableGrid.Text xs={3}>
                    {t("occurrences.ra", { ra: student.ra })}
                  </TableGrid.Text>
                  <TableGrid.Cell xs={1}>
                    <Checkbox
                      checked={selectedStudents.some(
                        selected => selected.id === student.id
                      )}
                      onChange={() => this.onSelectStudent(student)}
                      color="primary"
                    />
                  </TableGrid.Cell>
                </TableGrid.Row>
              ))}
            </TableGrid>
          </DialogContent>

          <DialogActions>
            <Button
              variant="contained"
              color="primary"
              onClick={() => this.setState({ openChangeSelectDialog: false })}
            >
              {t("common.actions.save")}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

Occurrences.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string
    })
  }).isRequired,
  alert: PropTypes.shape({
    show: PropTypes.func
  }).isRequired,
  jobsState: PropTypes.shape({
    jobs: PropTypes.arrayOf(PropTypes.shape())
  }).isRequired,
  t: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  jobsState: state.jobsState
});

export default withTranslation()(
  withAlert()(withRouter(connect(mapStateToProps)(Occurrences)))
);
